import useAuthStore from '@store/AuthStore';

/**
 * Custom hook that determines if a user has completed the Brain Games assessments
 * @returns boolean indicating if user has completed any of the brain games assessments
 */
export const useHasTakenBrainGames = (): boolean => {
  const { authSession } = useAuthStore();
  const { userData } = authSession || {};

  const hasTakenBrainGames = userData?.productData?.some(
    (product) =>
      product.product === 'discovery' &&
      product.data?.assessmentsStatus &&
      (product.data.assessmentsStatus.summit === 'results_ready' ||
        product.data.assessmentsStatus.snapshot === 'results_ready' ||
        product.data.assessmentsStatus.snippet === 'results_ready'),
  );

  return !!hasTakenBrainGames;
};

export default useHasTakenBrainGames;
